const Food = ({size, color}) => {
    return (  
        <>
            <svg 
                fill={color} 
                width={size} 
                height={size} 
                viewBox="0 0 50 50" enable-background="new 0 0 50 50" version="1.1" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
            >

            <g id="Layer_13">

            <path clip-rule="evenodd" d="M14.015,34.455l-2.313,0.839c-1.611-4.428-4.206-12.453-0.489-16.182   c2.909-2.914,7.903-2.399,10.473,0.726L19.789,21.4c-1.635-1.992-4.961-2.427-6.83-0.553   C10.272,23.539,12.828,31.191,14.015,34.455 M30.328,10.765c-0.803,1.536-2.143,2.587-4.21,3.149   c-0.541-2.066-0.301-3.753,0.629-5.219c0.933-1.469,2.549-2.799,4.76-4.114C31.474,7.159,31.133,9.226,30.328,10.765z    M45.275,24.359c0-6.961-5.92-12.361-12.838-11.677c2.261-3.634,1.9-8.579,1.714-12.682c-3.455,1.792-7.582,3.805-9.733,7.151   c-0.622-1.879-1.394-3.705-2.323-5.46l-3.182,1.516c1.858,3.427,3.613,7.224,4.347,11.456c-7.94-5.069-18.534-0.049-18.534,9.698   c0.022,5.967,2.899,15.34,6.224,20.276C13.093,47.818,15.796,50,19.072,50c1.879,0,4.197-1.001,5.93-1.577   c1.768,0.587,4.037,1.577,5.948,1.569c3.262-0.015,5.967-2.203,8.116-5.386C42.414,39.646,45.277,30.363,45.275,24.359z" fill-rule="evenodd"/>

            </g>

            <g id="Layer_12"/>

            <g id="Layer_11"/>

            <g id="Layer_10"/>

            <g id="Layer_9"/>

            <g id="Layer_8"/>

            <g id="Layer_7"/>

            <g id="Layer_6"/>

            <g id="Layer_5"/>

            <g id="Layer_4"/>

            <g id="Layer_3"/>

            <g id="Layer_2"/>

            </svg>
        </>
    );
}
 
export default Food;